<template lang="pug">
  .btn-refresh(v-if="!state" @click="refresh()")
    i.fal.fa-redo-alt
    span {{ counter }}
  .btn-refresh(v-else)
    i.fad.fa-spinner.fa-spin
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean
    },
    counter: {
      type: Number
    }
  },
  methods: {
    refresh() {
      this.$emit("refresh"); 
    }
  }
}
</script>